import request from '@/utils/http';
// 用户列表
export const baseUserInfoList = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/list`,
        method: 'post',
        data: params
    });
};
// 导出用户数据
export const exportUserInfo = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/exportUserInfo`,
        method: 'post',
        data: params,
        responseType: 'blob'
    });
};
// 更新用户
export const userUpdate = params => {
    return request({
        url: `/api-ntp/ntp/baseUserInfo/update`,
        method: 'post',
        data: params
    });
};
// 新增用户数据权限
export const baseAddUserAuthorityData = params => {
    return request({
        url: `/api-ntp/ntp/baseUserAuthorityData/addUserAuthorityData`,
        method: 'post',
        data: params
    });
};
// 获取数据权限信息
export const baseUserAuthorityData = params => {
    return request({
        // eslint-disable-next-line max-len
        url: `/api-ntp/ntp/baseUserAuthorityData/getUserAuthorityData?anhzCode=${params.anhzCode}&authorityType=${params.authorityType}&orgName=${params.orgName}&userId=${params.userId}&isSelected=${params.isSelected}`,
        method: 'get'
    });
};
// 获取数据权限机构
export const getUserOrgDataByAnhzCode = params => {
    return request({
        // eslint-disable-next-line max-len
        url: `/api-ntp/ntp/baseUserAuthorityData/getUserOrgDataByAnhzCode?anhzCode=${params.anhzCode}&authorityType=${params.authorityType}&orgName=${params.orgName}`,
        method: 'get'
    });
};
// 获取用户数据权限信息
export const getUserAuthorityDataByuserId = data => {
    return request({
        url: `/api-ntp/ntp/baseUserAuthorityData/getUserAuthorityData/${data.id}`,
        method: 'get'
    });
};
// 用户角色新增
export const authUsersRoles = params => {
    return request({
        url: `/api-ntp/ntp/baseUserRole/authUsersRolesHz`,
        method: 'post',
        data: params
    });
};
// 用户角色查询列表
export const queryRolesByUser = params => {
    return request({
        url: `/api-ntp/ntp/baseUserRole/queryRolesByUser`,
        method: 'post',
        data: params
    });
};
// 允许用户角色新增查询列表
export const queryAllowAddRolesByUser = params => {
    return request({
        url: `/api-ntp/ntp/baseUserRole/queryAllowAddRolesByUser`,
        method: 'post',
        data: params
    });
};
// 删除角色
export const baseRoleDelete = params => {
    return request({
        url: `/api-ntp/ntp/baseUserRole/delete`,
        method: 'post',
        data: params
    });
};
// 分页查询数据权限
export const baseUserAuthorityDataList = params => {
    return request({
        url: `/api-ntp/ntp/baseUserAuthorityData/list`,
        method: 'post',
        data: params
    });
};
// 分页查询数据权限创建人
export const getBaseUserInfoList = params => {
    return request({
        url: `/api-ntp/ntp/baseUserAuthorityData/queryCreatorList`,
        method: 'post',
        data: params
    });
};
